var React = require('react');

function Feedback1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 10.964a1 1 0 0 1-1 1h-2.216l.056 1.921a.5.5 0 0 1-.798.416l-3.145-2.337H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v9.964zM3.625 6a.625.625 0 1 0 0 1.25h3.75a.625.625 0 1 0 0-1.25h-3.75zm0-3a.625.625 0 1 0 0 1.25h8.75a.625.625 0 1 0 0-1.25h-8.75z","fill":"#424242","fillRule":"evenodd"}));
}

Feedback1.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15"};

module.exports = Feedback1;

Feedback1.default = Feedback1;
